import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';



@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const currentToken = this.authenticationService.readTokenFromStorage().token;
        let newRequest = request.clone();
        if (this.authenticationService.isAuthenticated() && !request.url.includes(environment.fingerPrintDeviceUrlSecuGen)) {
            if (!request.headers.has("Authorization") && currentToken) {
                newRequest = newRequest.clone({ headers: request.headers.set(`Authorization`, `Bearer ${currentToken}`) })
            }
        }

        if (request.url.includes(environment.fingerPrintDeviceUrlSecuGen)) {
            newRequest = newRequest.clone({
                withCredentials: false
            });
        }

        return next.handle(newRequest);
    }
}
